import React, { createContext, useContext, useState, useMemo } from "react";

const dict = {
  ro: {
    nav: { story: "Poveste", products: "Vinuri", gallery: "Galerie", testimonials: "Mărturii", contact: "Contact" },
    hero: {
      eyebrow: "ELENUIT — Sub lună, fiecare clipă strălucește",
      title1: "Sub lună,",
      title2: "fiecare clipă strălucește.",
      subtitle:
        "O colecție rafinată de vinuri Nova, gândită pentru momentele care merită amintite. Eleganță minimalistă. Sticlărie sub clar de lună.",
      cta_shop: "Descoperă Vinurile",
      cta_story: "Povestea Noastră",
    },
    story: {
      eyebrow: "Povestea ELENUIT",
      title: "Eleganța născută din liniștea nopții.",
      lead: "Există momente în viață care nu se grăbesc. Momente care cer liniște pentru a fi savurate pe deplin: o cină liniștită alături de persoana iubită, o discuție profundă cu un prieten vechi la apus, sau pur și simplu acele clipe de introspecție de la finalul unei zile lungi.",
      body: "ELENUIT s-a născut exact din dorința de a onora aceste momente. Numele nostru, inspirat de misterul și rafinamentul nopții — „éle\" eleganță și „nuit\" noapte — este o promisiune: aceea de a aduce un strop de magie și rafinament în fiecare pahar.",
      cta_title: "Adaugă un strop de ELENUIT serii tale.",
      cta_body: "Ești gata să transformi un moment obișnuit într-o amintire prețioasă? Adaugă în coș sticla ta de ELENUIT NOVA și bucură-te de eleganță, direct la tine acasă.",
      cta_button: "Descoperă Colecția",
      tagline: "Sub lună, fiecare clipă strălucește.",
    },
    products: {
      eyebrow: "Colecția Nova",
      title: "Vinuri pentru momente luminate.",
      addToCart: "Adaugă în coș",
      lei: "lei",
      save: "Economisești 60 lei",
      featured: "Recomandat",
    },
    gift: {
      eyebrow: "Cadou Semnătură",
      title: "Setul Cadou ELENUIT",
      body:
        "Un set curat și luxos: o sticlă Nova Rosé, o sticlă Nova White, ambalaj minimalist cu semilună aurie și un card cu mesajul „Pot depăși orice provocare.“",
      cta: "Comandă Setul",
    },
    gallery: {
      eyebrow: "Galerie",
      title: "Momente sub lună.",
    },
    testimonials: {
      eyebrow: "Mărturii",
      title: "Voci sub clar de lună.",
      list: [
        {
          quote: "Setul cadou a fost cel mai elegant lucru pe care l-am dăruit. Designul, ambalajul, mesajul — totul perfect.",
          author: "Ioana M.",
          role: "Client fidel",
        },
        {
          quote: "Nova Rosé este vinul preferat al verii noastre. Fin, echilibrat, cu o notă rafinată de fructe roșii.",
          author: "Andrei P.",
          role: "Pasionat de vin",
        },
        {
          quote: "ELENUIT a transformat cina noastră aniversară într-o seară cinematografică. Recomand cu drag.",
          author: "Cristina & Radu",
          role: "Cuplu",
        },
      ],
    },
    newsletter: {
      eyebrow: "Newsletter",
      title: "Primește invitații exclusive.",
      body: "Lasă-ți emailul pentru lansări limitate, evenimente private și ritualuri sub lună.",
      placeholder: "Adresa ta de email",
      cta: "Abonează-te",
      success: "Mulțumim. Te-am adăugat pe lista lunii.",
      already: "Ești deja abonat.",
    },
    cart: {
      title: "Coșul tău",
      empty: "Coșul este gol.",
      total: "Total",
      checkout: "Finalizează Comanda",
      remove: "Elimină",
    },
    delivery: {
      title: "Detalii Livrare",
      subtitle: "Te rugăm să completezi adresa pentru livrare. După confirmare, vei fi redirecționat spre plata securizată.",
      full_name: "Nume complet",
      phone: "Telefon",
      email: "Email",
      address_line: "Adresă (stradă, număr, bloc, scară, apt.)",
      city: "Oraș",
      county: "Județ",
      postal_code: "Cod poștal",
      notes: "Observații (opțional)",
      back: "Înapoi la coș",
      pay: "Continuă spre plată",
      summary: "Sumar comandă",
      required: "Câmp obligatoriu",
    },
    checkout: {
      success_title: "Plată reușită",
      success_body: "Mulțumim pentru comandă. Vei primi confirmarea pe email.",
      cancel_title: "Plată anulată",
      cancel_body: "Comanda ta nu a fost finalizată. Poți relua oricând.",
      error_title: "Nu am putut verifica plata",
      error_body: "Comanda ta s-ar putea să fi fost procesată. Verifică emailul sau contactează-ne dacă suma a fost debitată.",
      checking: "Verificăm starea plății...",
      back: "Înapoi pe site",
    },
    footer: {
      tagline: "Sub lună, fiecare clipă strălucește.",
      rights: "Toate drepturile rezervate.",
      company: "REIA-AUGUSTIN S.R.L.",
      cui: "CUI 46373237",
      reg: "J22/2316/2022",
      address: "Str. Cuza Vodă, Nr. 81, Ap. Birou 5, Târgu Frumos, România",
      iban_label: "Cont bancar (BTRL)",
      iban: "RO24BTRLRONCRT0CP6999101",
      legal: "Date Companie",
    },
  },
  en: {
    nav: { story: "Story", products: "Wines", gallery: "Gallery", testimonials: "Voices", contact: "Contact" },
    hero: {
      eyebrow: "ELENUIT — Under the moon, every moment shines",
      title1: "Under the moon,",
      title2: "every moment shines.",
      subtitle:
        "A refined collection of Nova wines, crafted for moments that deserve to be remembered. Minimalist elegance. Glassware in moonlight.",
      cta_shop: "Discover the Wines",
      cta_story: "Our Story",
    },
    story: {
      eyebrow: "The ELENUIT Story",
      title: "Elegance born from the silence of night.",
      lead: "There are moments in life that don't rush. Moments that demand silence to be fully savored: a quiet dinner with a loved one, a deep conversation with an old friend at sunset, or simply those moments of introspection at the end of a long day.",
      body: "ELENUIT was born from the desire to honor these moments. Our name, inspired by the mystery and refinement of the night — \"éle\" elegance and \"nuit\" night — is a promise: to bring a touch of magic and refinement to every glass.",
      cta_title: "Add a touch of ELENUIT to your evening.",
      cta_body: "Ready to turn an ordinary moment into a precious memory? Add to cart your bottle of ELENUIT NOVA and enjoy elegance, delivered straight to your home.",
      cta_button: "Discover the Collection",
      tagline: "Under the moon, every moment shines.",
    },
    products: {
      eyebrow: "The Nova Collection",
      title: "Wines for illuminated moments.",
      addToCart: "Add to cart",
      lei: "lei",
      save: "You save 60 lei",
      featured: "Featured",
    },
    gift: {
      eyebrow: "Signature Gift",
      title: "The ELENUIT Wine Gift Set",
      body:
        "A clean, luxurious set: one bottle of Nova Rosé, one of Nova White, sleek packaging with a gold crescent moon, and an inspiration card reading “I can overcome any challenge.”",
      cta: "Order the Set",
    },
    gallery: {
      eyebrow: "Gallery",
      title: "Moments under the moon.",
    },
    testimonials: {
      eyebrow: "Voices",
      title: "Words by moonlight.",
      list: [
        {
          quote: "The gift set was the most elegant thing I've ever given. Design, packaging, message — flawless.",
          author: "Ioana M.",
          role: "Loyal client",
        },
        {
          quote: "Nova Rosé is our favorite summer wine. Fine, balanced, with refined red-fruit notes.",
          author: "Andrei P.",
          role: "Wine enthusiast",
        },
        {
          quote: "ELENUIT turned our anniversary dinner into a cinematic evening. Highly recommended.",
          author: "Cristina & Radu",
          role: "Couple",
        },
      ],
    },
    newsletter: {
      eyebrow: "Newsletter",
      title: "Receive exclusive invitations.",
      body: "Leave your email for limited drops, private events, and moonlit rituals.",
      placeholder: "Your email address",
      cta: "Subscribe",
      success: "Thank you. You're on the moonlit list.",
      already: "You're already subscribed.",
    },
    cart: {
      title: "Your cart",
      empty: "Your cart is empty.",
      total: "Total",
      checkout: "Checkout",
      remove: "Remove",
    },
    delivery: {
      title: "Delivery Details",
      subtitle: "Please complete your delivery address. After confirmation, you'll be redirected to secure payment.",
      full_name: "Full name",
      phone: "Phone",
      email: "Email",
      address_line: "Address (street, no., building, floor, apt.)",
      city: "City",
      county: "County / State",
      postal_code: "Postal code",
      notes: "Notes (optional)",
      back: "Back to cart",
      pay: "Continue to payment",
      summary: "Order summary",
      required: "Required field",
    },
    checkout: {
      success_title: "Payment successful",
      success_body: "Thank you for your order. A confirmation will arrive by email.",
      cancel_title: "Payment cancelled",
      cancel_body: "Your order was not completed. You can resume any time.",
      error_title: "We couldn't verify your payment",
      error_body: "Your order may have been processed. Check your email or contact us if the amount was charged.",
      checking: "Verifying payment status...",
      back: "Back to site",
    },
    footer: {
      tagline: "Under the moon, every moment shines.",
      rights: "All rights reserved.",
      company: "REIA-AUGUSTIN S.R.L.",
      cui: "VAT 46373237",
      reg: "J22/2316/2022",
      address: "Str. Cuza Vodă, No. 81, Office 5, Târgu Frumos, Romania",
      iban_label: "Bank account (BTRL)",
      iban: "RO24BTRLRONCRT0CP6999101",
      legal: "Company Details",
    },
  },
};

const I18nCtx = createContext(null);

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState("ro");
  const value = useMemo(
    () => ({ lang, setLang, t: dict[lang], toggle: () => setLang((l) => (l === "ro" ? "en" : "ro")) }),
    [lang]
  );
  return <I18nCtx.Provider value={value}>{children}</I18nCtx.Provider>;
};

export const useI18n = () => useContext(I18nCtx);
